import SessionStorageCache from 'lyjs/es/cache/SessionStorageCache'

export default new SessionStorageCache('profile')
